<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader'>
                        <h2 id="titleHeight">{{getLanguageOEMI(this.getUserInfo.OEMI,"AHRPT",'AHRPT') }}</h2>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"AHRPT",'AHRPT')}}</strong>
                    <div class="pageBtn" v-if="selectedNode && selectedNode.model.type == 'A' && selectedNode.model.subcount > 0">
                        <CButton color="primary" size="sm" class="mr-auto btnExcel" @click="openSubAgentHierarchy()">
                            {{this.getLanguage['BTN']['V']}} {{this.getLanguage['AHRPT']['SAHRPT']}}
                        </CButton>
                    </div>
                </header>
                <div class="custom-table-wrapper agent-hierarchy">
                    <v-treeview v-model="treeData"
                                :treeTypes="this.getUserInfo.OEMI==2?treeTypesOEM2:treeTypes"
                                @selected="selected"
                                :openAll="openAll" :openNode="openNode" @contextmenu.prevent>
                        <template v-slot:prepand="{item}">
                            <span v-if="item.isnew" class="badge badge-danger">{{getLanguage["GAME"]["NEW"]}}</span>
                            <span v-if="item.subcount > 0" class="subagent-link" @click="openSubAgent(item)">{{item.subcount}}</span>
                        </template>
                    </v-treeview>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import VTreeview from "@/views/CustomTreeView/CustomTreeview"
    import genericHelper from "@/modules/GenericHelper.js";
    import { mapGetters, mapActions } from 'vuex';
    import { loadingFullScreen } from '@/modules/Constant.js';

    export default {
        mixins: [genericHelper],
        components: {
            VTreeview,
            Loading
        },
        data() {
            return {
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                openAll: false,
                treeTypes: [
                    {
                        type: "#",
                        max_children: 99999,
                        max_depth: 4,
                        valid_children: [
                            "SSA"
                        ]
                    },
                    {
                        type: "SSA",
                        icon: "fas fa-user-shield gg-ico gg-ico-ssa",
                        valid_children: ["SA"]
                    },
                    {
                        type: "SA",
                        icon: "fas fa-user-alt gg-ico gg-ico-sa",
                        valid_children: ["MA"]
                    },
                    {
                        type: "MA",
                        icon: "fas fa-user-friends gg-ico gg-ico-ma",
                        valid_children: ["A"]
                    },
                    {
                        type: "A",
                        icon: "fas fa-users gg-ico gg-ico-a",
                        valid_children: ["DN", "SAG"]
                    },
                    {
                        type: "DN",
                        icon: "fas fa-link",
                        valid_children: []
                    },
                    {
                        type: "SAG",
                        icon: "fas fa-users gg-ico gg-ico-sag",
                        valid_children: ["DN"]
                    }
                ],
                treeTypesOEM2: [
                    {
                        type: "#",
                        max_children: 99999,
                        max_depth: 4,
                        valid_children: [
                            "SSA"
                        ]
                    },
                    {
                        type: "SSA",
                        icon: "fas fa-user-shield gg-ico gg-ico-ssa",
                        valid_children: ["SA"]
                    },
                    {
                        type: "SA",
                        icon: "fas fa-user-alt gg-ico gg-ico-sa-oem2",
                        valid_children: ["MA"]
                    },
                    {
                        type: "MA",
                        icon: "fas fa-user-friends gg-ico gg-ico-ma-oem2",
                        valid_children: ["A"]
                    },
                    {
                        type: "A",
                        icon: "fas fa-users gg-ico gg-ico-a-oem2",
                        valid_children: ["DN", "SAG"]
                    },
                    {
                        type: "DN",
                        icon: "fas fa-link",
                        valid_children: []
                    },
                    {
                        type: "SAG",
                        icon: "fas fa-users gg-ico gg-ico-sag-oem2",
                        valid_children: ["DN"]
                    }
                ],
                treeData: [],
                contextItems: [],
                selectedNode: null,
                openNode: null,
            }
        },
        methods: {
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;

                this.getDataApi(`/api/dd/ag-h`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d && d.D) {
                                that.treeData = d.D;

                                if (that.getUserInfo.AT < 2) {
                                    that.openAll = false;
                                    that.openNode = d.D[0].id;
                                } else {
                                    that.openAll = true;
                                    that.openNode = null;
                                }
                            }
                            else {
                                that.treeData = [];
                            }
                        }
                        else {
                            that.treeData = [];
                        }
                    });
            },
            selected(node) {
                this.selectedNode = node;
            },
            openSubAgentHierarchy() {
                if (this.selectedNode.model.type == 'A') {
                    let routeData = this.$router.resolve({ path: '/AGS/SUBHRY', query: { agi: '3-'+this.selectedNode.model.id } });
                    window.open(routeData.href, '_blank');
                }
            },
            openSubAgent(item) {
                let routeData = this.$router.resolve({ path: '/AGS/SUBHRY', query: { agi: '3-' + item.id } });
                window.open(routeData.href, '_blank');
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        watch: {
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.AHRY';
            this.getReportList();
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/AgentHierarchy.vue